// 漫画作品模拟数据
export const comicCategories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'romance', name: '恋爱', slug: 'romance' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy' },
  { id: 'action', name: '热血', slug: 'action' },
  { id: 'drama', name: '剧情', slug: 'drama' },
  { id: 'comedy', name: '搞笑', slug: 'comedy' },
  { id: 'thriller', name: '悬疑', slug: 'thriller' },
  { id: 'slice-of-life', name: '日常', slug: 'slice-of-life' },
  { id: 'horror', name: '惊悚', slug: 'horror' },
];

export const categories = comicCategories;

export const comics = [
  {
    id: 1,
    title: '樱花盛开的季节',
    originalTitle: '벚꽃이 피는 계절',
    author: '金智秀',
    category: 'romance',
    tags: ['恋爱', '校园', '青春'],
    description: '高中最后一年，她遇见了那个改变一切的转学生。在樱花纷飞的校园里，两颗年轻的心悄然靠近。这是一段关于成长、勇气与初恋的甜蜜故事，带你重回那段青涩美好的时光。',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20pink%20and%20warm%20golden%20tones%2C%20romantic%20atmosphere%2C%20anime%20art%20style%2C%20clean%20lines%2C%20dreamy%20bokeh%20background%2C%20gentle%20expressions%2C%20school%20uniform%2C%20digital%20illustration%20with%20watercolor%20texture&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    rating: 9.7,
    views: 1280000,
    status: '连载中',
    updatedAt: '2026-07-07',
    chapters: 86,
    chapterList: [
      { num: 86, title: '最后的告白', date: '2026-07-07' },
      { num: 85, title: '雨中的约定', date: '2026-06-30' },
      { num: 84, title: '无法说出口的话', date: '2026-06-23' },
      { num: 83, title: '意外的重逢', date: '2026-06-16' },
      { num: 82, title: '离别的车站', date: '2026-06-09' },
      { num: 81, title: '写在毕业之前', date: '2026-06-02' },
      { num: 80, title: '她的选择', date: '2026-05-26' },
      { num: 79, title: '深夜的电话', date: '2026-05-19' },
      { num: 78, title: '樱花树下的誓言', date: '2026-05-12' },
      { num: 77, title: '你的梦想', date: '2026-05-05' },
      { num: 76, title: '情敌的挑战', date: '2026-04-28' },
      { num: 75, title: '第一次约会', date: '2026-04-21' },
      { num: 74, title: '天台上的秘密', date: '2026-04-14' },
      { num: 73, title: '学园祭的告白', date: '2026-04-07' },
      { num: 72, title: '错过的信息', date: '2026-03-31' },
      { num: 71, title: '手心里的温暖', date: '2026-03-24' },
      { num: 70, title: '雨停了之后', date: '2026-03-17' },
      { num: 69, title: '分班危机', date: '2026-03-10' },
      { num: 68, title: '他的过去', date: '2026-03-03' },
      { num: 67, title: '初雪的约定', date: '2026-02-24' },
    ],
  },
  {
    id: 2,
    title: '暗影之王',
    originalTitle: '그림자의 왕',
    author: '朴宰范',
    category: 'action',
    tags: ['热血', '战斗', '奇幻'],
    description: '平凡高中生李晨在一次意外中觉醒了暗影之力，从此踏上成为暗影之王的征途。在这个充满异能者的世界里，他必须不断变强，才能保护所爱之人，揭开隐藏在暗处的惊天阴谋。',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20male%20warrior%20with%20shadow%20powers%2C%20purple%20and%20black%20energy%20surrounding%20him%2C%20intense%20expression%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20from%20below%2C%20anime%20art%20style%2C%20detailed%20armor%20design%2C%20dark%20moody%20atmosphere%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    rating: 9.5,
    views: 2150000,
    status: '连载中',
    updatedAt: '2026-07-06',
    chapters: 142,
    chapterList: [
      { num: 142, title: '终极对决', date: '2026-07-06' },
      { num: 141, title: '觉醒之力', date: '2026-06-29' },
      { num: 140, title: '黑暗深渊', date: '2026-06-22' },
      { num: 139, title: '王座之争', date: '2026-06-15' },
      { num: 138, title: '背叛者', date: '2026-06-08' },
      { num: 137, title: '影之军团', date: '2026-06-01' },
      { num: 136, title: '远古封印', date: '2026-05-25' },
      { num: 135, title: '破晓之战', date: '2026-05-18' },
      { num: 134, title: '宿命的对决', date: '2026-05-11' },
      { num: 133, title: '最后一个碎片', date: '2026-05-04' },
      { num: 132, title: '暗影之谷', date: '2026-04-27' },
      { num: 131, title: '新的盟友', date: '2026-04-20' },
      { num: 130, title: '真王的试炼', date: '2026-04-13' },
      { num: 129, title: '血色黎明', date: '2026-04-06' },
      { num: 128, title: '王冠的重量', date: '2026-03-30' },
      { num: 127, title: '禁忌之术', date: '2026-03-23' },
      { num: 126, title: '破碎的承诺', date: '2026-03-16' },
      { num: 125, title: '暗影议会', date: '2026-03-09' },
      { num: 124, title: '逃出生天', date: '2026-03-02' },
      { num: 123, title: '师父的遗言', date: '2026-02-23' },
    ],
  },
  {
    id: 3,
    title: '魔法学院的劣等生',
    originalTitle: '마법학교의 열등생',
    author: '李恩在',
    category: 'fantasy',
    tags: ['奇幻', '校园', '成长'],
    description: '在这个人人都能使用魔法的世界里，韩宇却是学院里唯一的魔力为零的学生。但他拥有超越所有人的体术天赋和对魔法的独特理解。当黑暗势力来袭，他将是学院最后的希望。',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20male%20student%20in%20a%20magic%20academy%20uniform%2C%20surrounded%20by%20floating%20magical%20runes%20and%20sparks%2C%20fantasy%20castle%20in%20background%2C%20blue%20and%20gold%20color%20scheme%2C%20anime%20art%20style%2C%20determined%20expression%2C%20holding%20a%20weapon%2C%20dramatic%20composition%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    rating: 9.3,
    views: 980000,
    status: '连载中',
    updatedAt: '2026-07-05',
    chapters: 64,
    chapterList: [
      { num: 64, title: '最终考试', date: '2026-07-05' },
      { num: 63, title: '隐藏的实力', date: '2026-06-28' },
      { num: 62, title: '魔法对决', date: '2026-06-21' },
      { num: 61, title: '新的同伴', date: '2026-06-14' },
      { num: 60, title: '禁术之书', date: '2026-06-07' },
      { num: 59, title: '地牢试炼', date: '2026-05-31' },
      { num: 58, title: '零的突破', date: '2026-05-24' },
      { num: 57, title: '学生会长的邀请', date: '2026-05-17' },
      { num: 56, title: '暗黑魔力', date: '2026-05-10' },
      { num: 55, title: '实战演练', date: '2026-05-03' },
      { num: 54, title: '图书馆的秘密', date: '2026-04-26' },
      { num: 53, title: '教授的过去', date: '2026-04-19' },
      { num: 52, title: '魔剑争夺战', date: '2026-04-12' },
      { num: 51, title: '意外觉醒', date: '2026-04-05' },
      { num: 50, title: '期中测验', date: '2026-03-29' },
      { num: 49, title: '森林深处的遗迹', date: '2026-03-22' },
      { num: 48, title: '四人小队', date: '2026-03-15' },
      { num: 47, title: '对练场的火花', date: '2026-03-08' },
      { num: 46, title: '学园规则', date: '2026-03-01' },
      { num: 45, title: '入学第一课', date: '2026-02-22' },
    ],
  },
  {
    id: 4,
    title: '首尔爱情故事',
    originalTitle: '서울 연애 이야기',
    author: '崔敏雅',
    category: 'romance',
    tags: ['恋爱', '都市', '职场'],
    description: '在繁华的首尔，两个性格迥异的年轻人在一家广告公司相遇。她是追求完美的创意总监，他是随性洒脱的新人设计师。从互看不顺眼到彼此吸引，都市里的浪漫故事就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20in%20modern%20Seoul%20cityscape%2C%20night%20city%20lights%20background%2C%20elegant%20office%20attire%2C%20romantic%20mood%2C%20warm%20neon%20glow%2C%20anime%20art%20style%2C%20soft%20romantic%20color%20palette%2C%20beautiful%20character%20design%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    rating: 9.6,
    views: 1560000,
    status: '已完结',
    updatedAt: '2026-05-20',
    chapters: 120,
    chapterList: [
      { num: 120, title: '我们的结局（终章）', date: '2026-05-20' },
      { num: 119, title: '求婚', date: '2026-05-13' },
      { num: 118, title: '家人的祝福', date: '2026-05-06' },
      { num: 117, title: '共度余生', date: '2026-04-29' },
      { num: 116, title: '坦诚相对', date: '2026-04-22' },
      { num: 115, title: '升职风波', date: '2026-04-15' },
      { num: 114, title: '她的梦想', date: '2026-04-08' },
      { num: 113, title: '首尔的雪', date: '2026-04-01' },
      { num: 112, title: '前男友的出现', date: '2026-03-25' },
      { num: 111, title: '济州岛之旅', date: '2026-03-18' },
      { num: 110, title: '心动瞬间', date: '2026-03-11' },
      { num: 109, title: '同事的祝福', date: '2026-03-04' },
      { num: 108, title: '深夜加班', date: '2026-02-25' },
      { num: 107, title: '误会解除', date: '2026-02-18' },
      { num: 106, title: '第一次牵手', date: '2026-02-11' },
      { num: 105, title: '她的脆弱', date: '2026-02-04' },
      { num: 104, title: '竞争对手', date: '2026-01-28' },
      { num: 103, title: '汉江边的对话', date: '2026-01-21' },
      { num: 102, title: '年会之夜', date: '2026-01-14' },
      { num: 101, title: '新项目的火花', date: '2026-01-07' },
    ],
  },
  {
    id: 5,
    title: '猎魔人传说',
    originalTitle: '마물 사냥꾼 전설',
    author: '郑宇成',
    category: 'action',
    tags: ['热血', '魔幻', '战斗'],
    description: '古老的世界里，猎魔人是人类对抗黑暗的最后防线。年轻猎魔人韩烈的村庄被恶魔屠戮，为了复仇与守护，他踏上了寻找传说级武器的旅途。沿途中，他会遇到各种各样的同伴与敌人。',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20demon%20hunter%20with%20a%20large%20sword%2C%20wearing%20leather%20armor%2C%20standing%20in%20a%20dark%20forest%20with%20red%20moon%2C%20fantasy%20medieval%20setting%2C%20dramatic%20action%20pose%2C%20red%20and%20black%20color%20scheme%2C%20anime%20art%20style%2C%20intense%20atmosphere%2C%20detailed%20weapon%20design%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    rating: 9.4,
    views: 1870000,
    status: '连载中',
    updatedAt: '2026-07-06',
    chapters: 98,
    chapterList: [
      { num: 98, title: '龙之巢穴', date: '2026-07-06' },
      { num: 97, title: '远古契约', date: '2026-06-29' },
      { num: 96, title: '圣剑觉醒', date: '2026-06-22' },
      { num: 95, title: '生死之门', date: '2026-06-15' },
      { num: 94, title: '深渊之主', date: '2026-06-08' },
      { num: 93, title: '最后的猎魔人', date: '2026-06-01' },
      { num: 92, title: '熔岩巨兽', date: '2026-05-25' },
      { num: 91, title: '精灵之森', date: '2026-05-18' },
      { num: 90, title: '王都陷落', date: '2026-05-11' },
      { num: 89, title: '血月之夜', date: '2026-05-04' },
      { num: 88, title: '恶魔公爵', date: '2026-04-27' },
      { num: 87, title: '银色子弹', date: '2026-04-20' },
      { num: 86, title: '狼人部落', date: '2026-04-13' },
      { num: 85, title: '教堂地下', date: '2026-04-06' },
      { num: 84, title: '圣水与银', date: '2026-03-30' },
      { num: 83, title: '酒馆的委托', date: '2026-03-23' },
      { num: 82, title: '吸血鬼城堡', date: '2026-03-16' },
      { num: 81, title: '猎魔人公会', date: '2026-03-09' },
      { num: 80, title: '师父的教诲', date: '2026-03-02' },
      { num: 79, title: '复仇之路', date: '2026-02-23' },
    ],
  },
  {
    id: 6,
    title: '总裁的契约新娘',
    originalTitle: '회장님의 계약 신부',
    author: '韩智慧',
    category: 'drama',
    tags: ['剧情', '恋爱', '都市'],
    description: '为了拯救家族企业，她不得不接受一份契约婚姻。对方是那个冷酷无情的财阀总裁——所有人都说他铁石心肠，但只有她看到了他不为人知的温柔一面。一场始于交易的婚姻，最终能否变成真正的爱情？',
    cover: 'https://readdy.ai/api/search-image?query=A%20luxurious%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20couple%20in%20formal%20attire%2C%20the%20woman%20in%20a%20stunning%20wedding%20dress%2C%20the%20man%20in%20a%20sharp%20black%20suit%2C%20mansion%20interior%20background%20with%20chandeliers%2C%20dramatic%20moody%20lighting%2C%20anime%20art%20style%2C%20gold%20and%20burgundy%20tones%2C%20romantic%20yet%20tense%20atmosphere%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    views: 2340000,
    status: '连载中',
    updatedAt: '2026-07-07',
    chapters: 75,
    chapterList: [
      { num: 75, title: '真心话', date: '2026-07-07' },
      { num: 74, title: '危机来临', date: '2026-06-30' },
      { num: 73, title: '家族秘密', date: '2026-06-23' },
      { num: 72, title: '意外的拥抱', date: '2026-06-16' },
      { num: 71, title: '情敌出现', date: '2026-06-09' },
      { num: 70, title: '董事会的刁难', date: '2026-06-02' },
      { num: 69, title: '婚后第一夜', date: '2026-05-26' },
      { num: 68, title: '契约的条款', date: '2026-05-19' },
      { num: 67, title: '婚纱店风波', date: '2026-05-12' },
      { num: 66, title: '前女友的归来', date: '2026-05-05' },
      { num: 65, title: '慈善晚宴', date: '2026-04-28' },
      { num: 64, title: '他的笑容', date: '2026-04-21' },
      { num: 63, title: '母亲的反对', date: '2026-04-14' },
      { num: 62, title: '酒后的真心', date: '2026-04-07' },
      { num: 61, title: '协议签字', date: '2026-03-31' },
      { num: 60, title: '初次见面', date: '2026-03-24' },
      { num: 59, title: '公司危机', date: '2026-03-17' },
      { num: 58, title: '父亲的债务', date: '2026-03-10' },
      { num: 57, title: '豪宅初体验', date: '2026-03-03' },
      { num: 56, title: '那一纸婚约', date: '2026-02-24' },
    ],
  },
  {
    id: 7,
    title: '搞笑一家人之漫画版',
    originalTitle: '웃긴 가족 만화판',
    author: '朴善英',
    category: 'comedy',
    tags: ['搞笑', '日常', '家庭'],
    description: '以一个四口之家的日常生活为蓝本，记录那些令人捧腹大笑的家庭趣事。爸爸是个不着调的自由职业者，妈妈是全家的实际掌权者，姐姐是典型的完美主义者，而弟弟则是全家的搞笑担当。',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20heartwarming%20Korean%20manhwa%20style%20illustration%20of%20a%20family%20of%20four%20with%20exaggerated%20comedic%20expressions%2C%20bright%20living%20room%20setting%2C%20colorful%20and%20vibrant%20colors%2C%20anime%20art%20style%2C%20cartoonish%20and%20playful%20character%20design%2C%20warm%20lighting%2C%20chaotic%20but%20loving%20family%20scene%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    rating: 9.1,
    views: 890000,
    status: '连载中',
    updatedAt: '2026-07-04',
    chapters: 156,
    chapterList: [
      { num: 156, title: '家庭运动会', date: '2026-07-04' },
      { num: 155, title: '妈妈的秘密', date: '2026-06-27' },
      { num: 154, title: '爸爸的厨艺', date: '2026-06-20' },
      { num: 153, title: '姐姐的约会', date: '2026-06-13' },
      { num: 152, title: '弟弟的发明', date: '2026-06-06' },
      { num: 151, title: '超市大作战', date: '2026-05-30' },
      { num: 150, title: '家庭KTV之夜', date: '2026-05-23' },
      { num: 149, title: '奶奶驾到', date: '2026-05-16' },
      { num: 148, title: '爸爸的创业梦', date: '2026-05-09' },
      { num: 147, title: '减肥大计', date: '2026-05-02' },
      { num: 146, title: '偷吃外卖的凶手', date: '2026-04-25' },
      { num: 145, title: '妈妈的生日惊喜', date: '2026-04-18' },
      { num: 144, title: '遥控器争夺战', date: '2026-04-11' },
      { num: 143, title: '弟弟的宠物计划', date: '2026-04-04' },
      { num: 142, title: '姐姐的网络直播', date: '2026-03-28' },
      { num: 141, title: '大扫除灾难', date: '2026-03-21' },
      { num: 140, title: '爸爸的驾照考试', date: '2026-03-14' },
      { num: 139, title: '全家的露营之旅', date: '2026-03-07' },
      { num: 138, title: '弟弟的零花钱', date: '2026-02-28' },
      { num: 137, title: '谁偷吃了冰箱蛋糕', date: '2026-02-21' },
    ],
  },
  {
    id: 8,
    title: '迷雾都市',
    originalTitle: '안개 도시',
    author: '金贤重',
    category: 'thriller',
    tags: ['悬疑', '推理', '都市'],
    description: '刑警姜宇接手了一桩连环失踪案，所有线索都指向一个不存在的组织。随着调查深入，他发现这个案件与自己十年前失踪的父亲有着密不可分的联系。迷雾笼罩的都市里，真相正一步步浮出水面。',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20foggy%20urban%20alleyway%20at%20night%2C%20dim%20streetlight%2C%20noir%20atmosphere%2C%20blue%20and%20gray%20tones%2C%20anime%20art%20style%2C%20suspenseful%20mood%2C%20rain%20reflections%20on%20pavement%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    rating: 9.8,
    views: 1760000,
    status: '连载中',
    updatedAt: '2026-07-05',
    chapters: 52,
    chapterList: [
      { num: 52, title: '最后的线索', date: '2026-07-05' },
      { num: 51, title: '地下组织', date: '2026-06-28' },
      { num: 50, title: '父亲的日记', date: '2026-06-21' },
      { num: 49, title: '第五名受害者', date: '2026-06-14' },
      { num: 48, title: '暗号破解', date: '2026-06-07' },
      { num: 47, title: '废弃工厂', date: '2026-05-31' },
      { num: 46, title: '匿名举报信', date: '2026-05-24' },
      { num: 45, title: '目击证人', date: '2026-05-17' },
      { num: 44, title: '内部调查', date: '2026-05-10' },
      { num: 43, title: '第四名失踪者', date: '2026-05-03' },
      { num: 42, title: '监控死角', date: '2026-04-26' },
      { num: 41, title: '老搭档的秘密', date: '2026-04-19' },
      { num: 40, title: '雨夜追踪', date: '2026-04-12' },
      { num: 39, title: '神秘电话号码', date: '2026-04-05' },
      { num: 38, title: '第三起失踪', date: '2026-03-29' },
      { num: 37, title: '法医的报告', date: '2026-03-22' },
      { num: 36, title: '父亲的旧照片', date: '2026-03-15' },
      { num: 35, title: '地下停车场', date: '2026-03-08' },
      { num: 34, title: '第二个失踪者', date: '2026-03-01' },
      { num: 33, title: '案发现场', date: '2026-02-22' },
    ],
  },
  {
    id: 9,
    title: '猫咪咖啡厅',
    originalTitle: '고양이 카페',
    author: '尹秀雅',
    category: 'slice-of-life',
    tags: ['日常', '治愈', '猫咪'],
    description: '辞职后的她接手了一家濒临倒闭的猫咪咖啡厅。在这里，她遇见了各种各样的人和猫咪——失意的上班族、孤独的老人、迷茫的学生。每一只猫都有它的故事，每一个人都能在这里找到治愈。',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20a%20cat%20cafe%20surrounded%20by%20adorable%20cats%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20plants%20and%20books%2C%20soft%20pastel%20colors%2C%20anime%20art%20style%2C%20healing%20and%20peaceful%20atmosphere%2C%20cozy%20interior%20design%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: 720000,
    status: '已完结',
    updatedAt: '2026-04-15',
    chapters: 80,
    chapterList: [
      { num: 80, title: '新的开始（终章）', date: '2026-04-15' },
      { num: 79, title: '猫与人的缘分', date: '2026-04-08' },
      { num: 78, title: '春天的约定', date: '2026-04-01' },
      { num: 77, title: '小雪的故事', date: '2026-03-25' },
      { num: 76, title: '咖啡厅的日常', date: '2026-03-18' },
      { num: 75, title: '流浪猫救助行动', date: '2026-03-11' },
      { num: 74, title: '老爷爷与阿橘', date: '2026-03-04' },
      { num: 73, title: '学生志愿者的加入', date: '2026-02-25' },
      { num: 72, title: '猫咪生日派对', date: '2026-02-18' },
      { num: 71, title: '夜间的小客人们', date: '2026-02-11' },
      { num: 70, title: '打工女孩的梦想', date: '2026-02-04' },
      { num: 69, title: '花花的绝育手术', date: '2026-01-28' },
      { num: 68, title: '下雨天的咖啡厅', date: '2026-01-21' },
      { num: 67, title: '新猫入驻', date: '2026-01-14' },
      { num: 66, title: '社会人撸猫解压', date: '2026-01-07' },
      { num: 65, title: '猫咪领养日', date: '2025-12-31' },
      { num: 64, title: '圣诞节的特别菜单', date: '2025-12-24' },
      { num: 63, title: '撸猫的正确姿势', date: '2025-12-17' },
      { num: 62, title: '第一位常客', date: '2025-12-10' },
      { num: 61, title: '重新开业的第一天', date: '2025-12-03' },
    ],
  },
  {
    id: 10,
    title: '鬼怪公寓',
    originalTitle: '도깨비 아파트',
    author: '宋允儿',
    category: 'horror',
    tags: ['惊悚', '灵异', '都市传说'],
    description: '搬进廉价公寓的那天起，奇怪的事情就不断发生。半夜的脚步声、镜中的人影、消失的邻居……这座公寓里隐藏着不可告人的秘密，而她已经被卷入了这场无法逃脱的恐怖之中。',
    cover: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20manhwa%20style%20illustration%20of%20an%20old%20apartment%20building%20corridor%20with%20flickering%20lights%2C%20a%20shadowy%20figure%20lurking%2C%20dark%20and%20eerie%20atmosphere%2C%20greenish%20dim%20lighting%2C%20anime%20art%20style%2C%20horror%20elements%2C%20scratch%20marks%20on%20walls%2C%20ghost%20apparition%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    views: 1450000,
    status: '连载中',
    updatedAt: '2026-07-03',
    chapters: 48,
    chapterList: [
      { num: 48, title: '地下室的秘密', date: '2026-07-03' },
      { num: 47, title: '第十三层', date: '2026-06-26' },
      { num: 46, title: '镜中人', date: '2026-06-19' },
      { num: 45, title: '消失的301室', date: '2026-06-12' },
      { num: 44, title: '夜半脚步声', date: '2026-06-05' },
      { num: 43, title: '婴儿的哭声', date: '2026-05-29' },
      { num: 42, title: '电梯里的女人', date: '2026-05-22' },
      { num: 41, title: '管理员大叔', date: '2026-05-15' },
      { num: 40, title: '墙上的水渍', date: '2026-05-08' },
      { num: 39, title: '天台惊魂', date: '2026-05-01' },
      { num: 38, title: '朋友来访', date: '2026-04-24' },
      { num: 37, title: '深夜来电', date: '2026-04-17' },
      { num: 36, title: '走廊尽头的门', date: '2026-04-10' },
      { num: 35, title: '衣柜里的声音', date: '2026-04-03' },
      { num: 34, title: '前任租客的遗物', date: '2026-03-27' },
      { num: 33, title: '402室的新邻居', date: '2026-03-20' },
      { num: 32, title: '楼道里的童谣', date: '2026-03-13' },
      { num: 31, title: '第一次看到它', date: '2026-03-06' },
      { num: 30, title: '搬进公寓', date: '2026-02-27' },
      { num: 29, title: '那则租房广告', date: '2026-02-20' },
    ],
  },
  {
    id: 11,
    title: '异世界食堂',
    originalTitle: '이세계 식당',
    author: '姜东元',
    category: 'fantasy',
    tags: ['奇幻', '美食', '穿越'],
    description: '普通厨师张伟意外穿越到异世界，发现这里的食物难以下咽。凭借精湛的厨艺，他决定在这个剑与魔法的世界里开一家食堂。没想到，各路勇者、魔王、精灵纷纷成了他的忠实顾客。',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20style%20illustration%20of%20a%20chef%20in%20a%20fantasy%20world%20restaurant%2C%20serving%20delicious%20food%20to%20fantasy%20creatures%20like%20elves%20and%20knights%2C%20warm%20cozy%20tavern%20interior%2C%20steaming%20dishes%2C%20golden%20and%20brown%20tones%2C%20anime%20art%20style%2C%20appetizing%20food%20illustration%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-11&orientation=portrait',
    rating: 9.5,
    views: 1120000,
    status: '连载中',
    updatedAt: '2026-07-06',
    chapters: 68,
    chapterList: [
      { num: 68, title: '龙族的订单', date: '2026-07-06' },
      { num: 67, title: '传说中的食材', date: '2026-06-29' },
      { num: 66, title: '精灵的秘方', date: '2026-06-22' },
      { num: 65, title: '魔王驾到', date: '2026-06-15' },
      { num: 64, title: '勇者的最爱', date: '2026-06-08' },
      { num: 63, title: '矮人族的宴会', date: '2026-06-01' },
      { num: 62, title: '兽人厨师的挑战', date: '2026-05-25' },
      { num: 61, title: '魔法香料', date: '2026-05-18' },
      { num: 60, title: '公主的秘密菜单', date: '2026-05-11' },
      { num: 59, title: '深夜食客', date: '2026-05-04' },
      { num: 58, title: '妖精的甜点', date: '2026-04-27' },
      { num: 57, title: '美食大赛', date: '2026-04-20' },
      { num: 56, title: '传说中的厨具', date: '2026-04-13' },
      { num: 55, title: '异世界拉面', date: '2026-04-06' },
      { num: 54, title: '迷路的冒险者', date: '2026-03-30' },
      { num: 53, title: '公会会长的推荐', date: '2026-03-23' },
      { num: 52, title: '龙息烤牛排', date: '2026-03-16' },
      { num: 51, title: '史莱姆的蛋包饭', date: '2026-03-09' },
      { num: 50, title: '异世界第一单生意', date: '2026-03-02' },
      { num: 49, title: '穿越第一天', date: '2026-02-23' },
    ],
  },
  {
    id: 12,
    title: '我的ID是江南美人',
    originalTitle: '내 ID는 강남미인',
    author: '金泰熙',
    category: 'drama',
    tags: ['剧情', '校园', '成长'],
    description: '因为外貌被嘲笑的她，在高中毕业后做了整容手术，以全新面貌进入大学。但外表变美后，她发现世界并没有变得更好——人们对她外貌的偏见依然存在。一段关于自我认同与真正美丽的成长故事。',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20a%20university%20campus%20setting%2C%20elegant%20and%20confident%20expression%2C%20cherry%20blossom%20trees%2C%20soft%20spring%20lighting%2C%20anime%20art%20style%2C%20fashionable%20outfit%2C%20warm%20natural%20tones%2C%20dreamy%20atmosphere%2C%20digital%20illustration&width=800&height=1067&seq=comic-cover-12&orientation=portrait',
    rating: 9.4,
    views: 1980000,
    status: '已完结',
    updatedAt: '2026-03-28',
    chapters: 110,
    chapterList: [
      { num: 110, title: '真正的美丽（终章）', date: '2026-03-28' },
      { num: 109, title: '自信的笑容', date: '2026-03-21' },
      { num: 108, title: '和解', date: '2026-03-14' },
      { num: 107, title: '公开的秘密', date: '2026-03-07' },
      { num: 106, title: '校园祭', date: '2026-02-28' },
      { num: 105, title: '闺蜜的力量', date: '2026-02-21' },
      { num: 104, title: '整容的代价', date: '2026-02-14' },
      { num: 103, title: '素颜的勇气', date: '2026-02-07' },
      { num: 102, title: '社团招新', date: '2026-01-31' },
      { num: 101, title: '他的表白', date: '2026-01-24' },
      { num: 100, title: '第一百话特辑', date: '2026-01-17' },
      { num: 99, title: '整容传闻', date: '2026-01-10' },
      { num: 98, title: '高中同学聚会', date: '2026-01-03' },
      { num: 97, title: '新生MT', date: '2025-12-27' },
      { num: 96, title: '校草学长', date: '2025-12-20' },
      { num: 95, title: '室友的秘密', date: '2025-12-13' },
      { num: 94, title: '选课风波', date: '2025-12-06' },
      { num: 93, title: '新生的目光', date: '2025-11-29' },
      { num: 92, title: '大学第一天', date: '2025-11-22' },
      { num: 91, title: '蜕变之后', date: '2025-11-15' },
    ],
  },
];

// 用户评价模拟数据
export const reviews = [
  { id: 1, name: '漫画爱好者小王', avatar: '王', comment: '飞飞漫画的资源真的太全了！追了好久的韩漫在这里都能找到，更新速度也很快，再也不用担心看不了最新的章节了。强烈推荐！', rating: 5, date: '2026-06-28' },
  { id: 2, name: '韩漫迷妹小美', avatar: '美', comment: '界面设计简洁大方，浏览体验超级流畅。特别喜欢书签功能，可以随时标记阅读进度，太贴心了！', rating: 5, date: '2026-06-25' },
  { id: 3, name: '漫画控小李', avatar: '李', comment: '作为一个看了十多年漫画的老读者，飞飞漫画的质量真的没话说。翻译质量高，画面清晰，而且完全免费，良心平台！', rating: 5, date: '2026-06-22' },
  { id: 4, name: '夜猫子读者', avatar: '夜', comment: '深夜追漫的最佳伴侣！加载速度快，阅读模式舒适，还能调节亮度和翻页方式。开发者真的很懂读者需要什么。', rating: 4, date: '2026-06-20' },
  { id: 5, name: '宅女小陈', avatar: '陈', comment: '分类做得很细致，能找到很多小众但精品的韩漫。评论区也很有趣，和其他读者一起讨论剧情真的很开心！', rating: 5, date: '2026-06-18' },
  { id: 6, name: '上班族小赵', avatar: '赵', comment: '通勤路上必备！手机端适配做得很好，随时随地都能看。推荐给身边很多同事了，都在用飞飞漫画。', rating: 4, date: '2026-06-15' },
];

// 平台数据
export const platformStats = {
  totalComics: 12860,
  totalUsers: 5860000,
  dailyActive: 890000,
  totalViews: 328000000,
};

// 关于我们 - 品牌介绍
export const aboutInfo = {
  brandName: '飞飞漫画网',
  founded: 2018,
  intro: '飞飞漫画网成立于2018年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大漫画爱好者提供最全面、最便捷的韩国漫画阅读体验。凭借强大的资源整合能力和人性化的产品设计，飞飞漫画网已发展成为国内韩漫领域的标杆平台。',
  mission: '让每一位漫画爱好者都能轻松畅享优质韩国漫画内容，打造极致的在线阅读体验。',
  vision: '成为全球华人用户首选的韩国漫画阅读平台。',
  values: ['用户至上', '内容为王', '技术创新', '社区共建'],
  contact: {
    email: 'hello@lxsilk.cn',
    wechat: 'feifeimanhua',
    qq: '1234567890',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T3-A座 2501室',
  },
  milestones: [
    { year: 2018, event: '飞飞漫画网正式上线，收录韩漫作品2000部' },
    { year: 2019, event: '用户突破100万，上线移动端适配版本' },
    { year: 2020, event: '与韩国多家漫画平台达成内容合作，资源量翻倍' },
    { year: 2021, event: '平台总用户数突破500万，推出社区互动功能' },
    { year: 2022, event: '上线AI智能推荐系统，个性化阅读体验全面升级' },
    { year: 2023, event: '获评年度最佳漫画阅读平台，日活跃用户突破80万' },
    { year: 2024, event: '平台资源突破12000部，覆盖全品类韩国漫画' },
    { year: 2025, event: '用户总数跨越500万大关，成为行业领军品牌' },
  ],
  faqs: [
    { question: '飞飞漫画网的漫画资源是否免费？', answer: '飞飞漫画网提供大量免费韩国漫画资源，用户注册后即可免费阅读。部分独家内容可能需要会员权限或等待限免活动。我们致力于在保障创作者权益的同时，为用户提供最优质且实惠的阅读体验。' },
    { question: '如何使用飞飞漫画网的搜索功能？', answer: '您可以在首页顶部的搜索框中输入漫画名称、作者名或相关关键词进行搜索。系统支持模糊搜索和智能联想，帮助您快速找到想看的内容。同时也可以通过分类页面按类别浏览所有漫画作品。' },
    { question: '飞飞漫画网支持哪些设备阅读？', answer: '飞飞漫画网支持PC端网页、手机浏览器、平板等所有主流设备访问。页面采用响应式设计，自动适配不同屏幕尺寸，确保在任何设备上都能获得流畅舒适的阅读体验。' },
    { question: '漫画更新频率是怎样的？', answer: '不同作品的更新频率根据原作者和版权方的安排而有所不同。热门连载作品通常每周更新1-2话，部分周更作品会在固定日期更新。您可以关注作品页面获取最新更新通知。' },
    { question: '如何联系飞飞漫画网的客服？', answer: '您可以通过以下方式联系我们：发送邮件至 hello@lxsilk.cn，添加微信 feifeimanhua，拨打客服热线 400-888-6666（工作日 9:00-18:00），或访问关于我们页面提交在线反馈。我们的客服团队会在24小时内回复您的咨询。' },
  ],
};
